import { RiSpeedUpLine } from '@remixicon/react';

import {
  Button,
  Menu,
  MenuRoot,
  MenuRow,
  PortalContainerContext,
} from '@spotify-internal/encore-web';
import { Popover } from '@spotify-internal/encore-web/next';

import styles from './SpeedMenu.module.css';

const SPEED_OPTIONS = [0.5, 0.75, 1, 2, 4, 8];

type SpeedMenuProps = {
  speed: number;
  onSpeedChange: (speed: number) => void;
  menuContainer?: HTMLElement;
};

export const SpeedMenu = ({
  speed,
  onSpeedChange,
  menuContainer,
}: SpeedMenuProps) => (
  <PortalContainerContext.Provider value={menuContainer}>
    <MenuRoot>
      <Button
        type="button"
        size="small"
        variant="tertiary"
        aria-label="Playback speed"
        className={styles.trigger}
      >
        <RiSpeedUpLine size={16} aria-hidden />
        {speed}x
      </Button>
      <Popover placement="top" hasNoArrow>
        <Menu aria-label="Playback speed options" rowSize="small">
          {SPEED_OPTIONS.map(speedOption => (
            <MenuRow
              key={speedOption}
              textValue={`${speedOption}x`}
              variant={speedOption === speed ? 'selected' : undefined}
              data-track-id="menuitem.playback-speed"
              data-track-action="update"
              data-track-data-playback-speed={speedOption}
              onAction={() => onSpeedChange(speedOption)}
            >
              {speedOption}x
            </MenuRow>
          ))}
        </Menu>
      </Popover>
    </MenuRoot>
  </PortalContainerContext.Provider>
);
